import {
  Avatar,
  Badge,
  Box,
  Divider,
  ListItem,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { CONVO_PREVIEW_ID } from "../../../enums/QueryKeys";
import useUser from "../../../hooks/useUser";
import ConversationMenu from "./ConversationMenu";
import usePrimaryColor from "../../../hooks/usePrimaryColor";

export default function Conversation({ conv }) {
  const [searchParams, setSearchParams] = useSearchParams();
  const convoParam = searchParams.get("convo");
  const primary = usePrimaryColor();
  const { profile } = useUser();
  const key = CONVO_PREVIEW_ID + conv?.id;

  const conversation = { ...conv };

  if (Number(convoParam) === conversation?.id) {
    conversation.read = true;
  }

  const isRead = conversation.read;
  const isReceiver = Number(conversation?.receiverId) === Number(profile?.id);

  const handleClickConvo = () => {
    searchParams.set("convo", conversation.id);
    setSearchParams(searchParams);
  };

  return (
    <React.Fragment key={conversation.id}>
      <ListItem
        button
        selected={conversation.id === convoParam}
        onClick={handleClickConvo}
        secondaryAction={<ConversationMenu convoId={conversation?.id} senderId={conversation?.senderId} />}
        sx={{ width: "100%" }}
        data-testid={`inbox.conversation-list.item.${conversation.id}`}
      >
        <Badge
          color="error"
          variant="dot"
          overlap="circular"
          invisible={isRead}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          sx={{ mr: 2 }}
        >
          <Avatar sx={{bgcolor: primary, color:"white"}}>
            {(isReceiver
              ? conversation?.senderEmail
              : conversation?.receiverEmail
            )?.charAt(0)}
          </Avatar>
        </Badge>

        <ListItemText
          primary={
            <Box display="flex" justifyContent="space-between">
              <Stack>
                <Typography variant="subtitle1">
                  {isReceiver ? conversation?.senderEmail : conversation?.receiverEmail}
                </Typography>
                <Typography variant="subtitle2" fontWeight={isRead ? "normal" : "bolder"} color={isRead ? "text.secondary" : "text.primary"}>
                  {conversation?.preview}
                </Typography>
                <Typography mt={1} variant="caption" color="text.secondary">
                  {conversation?.sentAt}
                </Typography>
              </Stack>
            </Box>
          }
        />
      </ListItem>

      <Divider sx={{ width: "100%" }} />
    </React.Fragment>
  );
}
